import { all, call, put, takeLatest } from 'redux-saga/effects'
import {REQUEST_AUTH_INFO, RECEIVE_AUTH_INFO } from '../constants'
import { fetchAuthInfo } from '../services'

function* yieldAuthUser(action: any) {
  try {
    const response = yield call(fetchAuthInfo, action.payload)
    yield put({ type: RECEIVE_AUTH_INFO, ...response })
  } catch(err) {
    console.log(err)
  }
}

export function* watchYieldAuth() {
  yield all([
    takeLatest(REQUEST_AUTH_INFO, yieldAuthUser),
  ])
}



// WEBPACK FOOTER //
// ./src/saga/auth.tsx